{
  "title": "Activity log",
  "subtitle": "What each person has been doing in the workspace.",
  "empty_title": "No activity yet",
  "empty_desc": "When someone creates, edits, completes, comments on or assigns tasks, it will show up here.",
  "empty_filtered": "No activity from this person in the selected period.",
  "load_more": "Load more",
  "loading": "Loading…",
  "someone": "Someone",
  "filter_person": "Person",
  "filter_all_people": "Whole team",
  "filter_event": "Action",
  "filter_all_events": "All",
  "clear_filters": "Clear filters",
  "subject": {
    "task": "task",
    "project": "project",
    "comment": "task"
  },
  "event": {
    "created_task": "created {subject} {name}",
    "updated_task": "updated {subject} {name}",
    "completed_task": "completed {subject} {name}",
    "deleted_task": "deleted {subject} {name}",
    "assigned_task": "assigned {subject} {name} to {people}",
    "unassigned_task": "removed {people} from {subject} {name}",
    "created_project": "created {subject} {name}",
    "updated_project": "updated {subject} {name}",
    "completed_project": "archived {subject} {name}",
    "deleted_project": "deleted {subject} {name}",
    "created_comment": "commented on {subject} {name}",
    "updated_comment": "edited a comment on {subject} {name}",
    "deleted_comment": "deleted a comment on {subject} {name}"
  },
  "event_label": {
    "created": "Created",
    "updated": "Edited",
    "completed": "Completed",
    "deleted": "Deleted",
    "assigned": "Assigned",
    "unassigned": "Unassigned"
  }
}
